import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { UserAuthenticatedLayout } from "@/layouts/AuthenticatedLayout/UserAuthenticatedLayout";
import { EmptyList } from "@/modules/theme/components/EmptyList/EmptyList";
import { PageMeta } from "@/modules/theme/components/PageMeta";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

const translationNamespace = "pages/TutorialsPage";

export const EmptyTutorialsView = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createEmptyTutorialsViewStyles(useTheme());

  return (
    <UserAuthenticatedLayout containerClassName={classes.root}>
      <PageMeta title={t("Tutorials")} />
      <Typography variant="pageHeading" className={classes.heading}>
        {t("Tutorials")}
      </Typography>
      <EmptyList>
        <>
          <Typography variant="contentMedium">
            {t("There are no tutorials available for you")}
          </Typography>
        </>
      </EmptyList>
    </UserAuthenticatedLayout>
  );
};

const createEmptyTutorialsViewStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      position: "relative",
    }),
    heading: css({
      marginBottom: spacing(3),
    }),
  };
};
